// Keeps a control that sits in a concealed container out of the form.
//
// A conditional field can be rendered once per reveal branch, when the branches
// are driven by different controls and the visitor moves between them without a
// page load. Every copy carries the same attribute name, so every copy submits
// and the last one wins -- letting a concealed, empty copy overwrite whatever
// the visible one collected.
//
// `hidden` stops neither serialization nor constraint validation. The validation
// half is the more serious of the two: a concealed `required` control makes the
// whole form invalid, so the browser refuses to submit and has no visible field
// to attach the message to.
//
// Disabling solves both. It has to happen as the control is concealed rather
// than on submit, because the submit event never fires while an invalid control
// is blocking the form.
//
// Matched on the attribute rather than on being concealed, so a field that
// genuinely wants to submit while hidden opts out by omitting it.
//
// Shared by the signup entrypoint and address_fields.js, so a page can use the
// address section without loading signup.js.
export const syncConcealedControls = (root = document) => {
  root.querySelectorAll("[data-disable-when-hidden]").forEach((control) => {
    control.disabled = Boolean(control.closest("[hidden]"));
  });
};
